import { EntityForm } from "../../module/superAdmin/form/EntityFrom";
import {
  addInitialSettledDb,
  getEntities,
  getEntityById,
  loadInitialSettledDb,
} from "../../services/firebase/entities";
import { AppState } from "../reducers/rootReducer";
import { IEntitiesAction, IInitialSettled, Types } from "../types/types";
import {
  setErrorMsg,
  setSuccessMsg,
  uiOpenErrorAlert,
  uiOpenSuccessAlert,
} from "./uiActions";
import {WorkScheduleFormValues} from "../../module/superAdmin/form/WorkScheduleFormValues";
import {
  createSpecialDay, deleteSpecialDay,
  getAllSpecialDays,
  loadWorkSchedule,
  saveWorkSchedule
} from "../../module/superAdmin/firebase/EntityService";
import {SpecialDay} from "../../module/superAdmin/form/SpecialDay";
export const startLoadEntities = () => {
  return async (dispatch: any) => {
    const response = await getEntities();
    if (response) {
      dispatch(loadEntities(response));
    }
  };
};
export const loadEntities = (entities: EntityForm[]): IEntitiesAction => ({
  type: Types.entitiesLoad,
  payload: entities,
});


export const addEntity = (entity: EntityForm): IEntitiesAction => ({
  type: Types.addEntity,
  payload: entity,
});

export const editEntity = (entity: EntityForm): IEntitiesAction => ({
  type: Types.editEntity,
  payload: entity,
});

export const startDeleteEntity = (idEntity: string) => {
  return (dispatch: any) => {
    //falta borrar de firebase
    dispatch(deleteEntity(idEntity));
  };
};
export const deleteEntity = (idEntity: string): IEntitiesAction => ({
  type: Types.deleteEntity,
  payload: idEntity,
});
export const setActiveEntity = (entity: EntityForm): IEntitiesAction => ({
  type: Types.setActiveEntity,
  payload: entity,
});
export const purgeActiveEntity = (): IEntitiesAction => ({
  type: Types.purgeActiveEntity,
});

/* ACTION LOAD INITIAL SETTLED IN ENTITY*/
export const startLoadInitialSettled = (idEntity: string) => {
  return async (dispatch: Function) => {
    const initialSettled = await loadInitialSettledDb(idEntity);
    if (initialSettled) {
      dispatch(setInitialSettledRedux(initialSettled));
    }
  };
};

export const getEntity = (idEntity: string) => {
  return async (dispatch: Function) => {
    const entity = await getEntityById(idEntity);
    dispatch(setActiveEntity(entity as EntityForm));
  };
};

/* ACTION SAVE INITIAL SETTLED IN ENTITY */
export const startSetInitialSettled = (data: IInitialSettled) => {
  return async (dispatch: any, getState: Function) => {
    const { user } = (getState() as AppState).auth;
    if (user && user.idEntity) {
      const { ok } = await addInitialSettledDb(user.idEntity, data);
      if (ok) {
        dispatch(setInitialSettledRedux(data.initialSettled));
        dispatch(setSuccessMsg("AddInitialSettledSucces"));
        dispatch(uiOpenSuccessAlert());
      } else {
        dispatch(setErrorMsg("AddInitialSettledError"));
        dispatch(uiOpenErrorAlert());
      }
    }
  };
};

/* ACTION REDUX SAVE AND LOAD INITIAL SETTLED */
export const setInitialSettledRedux = (
  initialSettled: string
): IEntitiesAction => ({
  type: Types.addInitialSettled,
  payload: initialSettled,
});

/**
 * Acción asíncrona que guarda la configuración del horario laboral en Firestore
 * para la entidad activa del usuario autenticado.
 *
 * Utiliza `saveWorkSchedule` para persistir los datos y despacha
 * alertas de éxito o error según el resultado.
 *
 * @param form - Valores del formulario de horario laboral.
 * @returns Promesa con `{ ok: boolean }` indicando si la operación fue exitosa.
 */
export const startSetWorkSchedule = (form: WorkScheduleFormValues) => {
  return async (dispatch: any, getState: Function) => {
    const { user } = (getState() as AppState).auth;
    if (user && user.idEntity) {
      const result = await saveWorkSchedule(user.idEntity, form);
      if (result.ok) {
        dispatch(setSuccessMsg("Horario laboral actualizado"));
        dispatch(uiOpenSuccessAlert());
      } else {
        dispatch(setErrorMsg("Error al guardar el horario laboral"));
        dispatch(uiOpenErrorAlert());
      }
      return result;
    }
    return { ok: false };
  };
};

/**
 * Acción asíncrona que carga la configuración del horario laboral
 * desde Firestore para la entidad activa del usuario autenticado.
 *
 * Utiliza `loadWorkSchedule` para obtener los datos asociados.
 *
 * @returns Promesa con los datos del horario (`IWorkScheduleDoc`) o `null` si no existe o falla.
 */
export const startLoadWorkSchedule = () => {
  return async (dispatch: any, getState: Function) => {
    const { user } = (getState() as AppState).auth;
    if (user && user.idEntity) {
      const result = await loadWorkSchedule(user.idEntity);
      return result;
    }
    return null;
  };
};


/**
 * Acción asíncrona que obtiene todos los días especiales desde Firestore
 * para la entidad activa del usuario autenticado.
 *
 * Utiliza `getAllSpecialDays` y despacha `loadSpecialDays` con los resultados.
 *
 * @returns {Promise<void>}
 */
export const startLoadSpecialDays = () => {
  return async (dispatch: any, getState: () => AppState) => {
    const { user } = getState().auth;
    if (user?.idEntity) {
      const result = await getAllSpecialDays(user.idEntity);
      dispatch(loadSpecialDays(result));
    }
  };
};

/**
 * Acción que almacena en el estado global los días especiales cargados desde Firestore.
 *
 * @param specialDays - Lista de días especiales obtenidos desde la base de datos.
 * @returns Acción de tipo `Types.specialDaysLoad`.
 */
export const loadSpecialDays = (specialDays: SpecialDay[]) => ({
  type: Types.specialDaysLoad,
  payload: specialDays,
});

/**
 * Acción asíncrona que crea un nuevo día especial en Firestore
 * para la entidad activa del usuario autenticado.
 *
 * Utiliza `createSpecialDay` y despacha `addSpecialDay` si la operación es exitosa.
 * También muestra mensajes de éxito o error mediante `MyAlert`.
 *
 * @param day - Objeto `SpecialDay` con la información del día especial a agregar.
 * @returns {Promise<void>}
 */
export const startAddSpecialDay = (day: SpecialDay) => {
  return async (dispatch: any, getState: () => AppState) => {
    const { user } = getState().auth;
    if (user?.idEntity) {
      const { ok } = await createSpecialDay(user.idEntity, day);
      if (ok) {
        dispatch(addSpecialDay(day));
        dispatch(setSuccessMsg("SpecialDaySaved"));
        dispatch(uiOpenSuccessAlert());
      } else {
        dispatch(setErrorMsg("Error al guardar día especial"));
        dispatch(uiOpenErrorAlert());
      }
    }
  };
};

/**
 * Acción que agrega un nuevo día especial al estado global.
 *
 * @param day - Objeto `SpecialDay` a agregar en Redux.
 * @returns Acción de tipo `Types.specialDayAdd`.
 */
export const addSpecialDay = (day: SpecialDay) => ({
  type: Types.specialDayAdd,
  payload: day,
});

/**
 * Acción asíncrona que elimina un día especial desde Firestore
 * para la entidad activa del usuario autenticado.
 *
 * Utiliza `deleteSpecialDay` y si es exitosa, despacha `removeSpecialDay`.
 *
 * @param id - ID del día especial a eliminar.
 * @returns {Promise<void>}
 */
export const startDeleteSpecialDay = (id: string) => {
  return async (dispatch: any, getState: () => AppState) => {
    const { user } = getState().auth;
    if (user?.idEntity) {
      const { ok } = await deleteSpecialDay(user.idEntity, id);
      if (ok) {
        dispatch(removeSpecialDay(id));
      }
    }
  };
};

/**
 * Acción que elimina un día especial del estado global.
 *
 * @param id - ID del día especial a remover de Redux.
 * @returns Acción de tipo `Types.specialDayDelete`.
 */
export const removeSpecialDay = (id: string) => ({
  type: Types.specialDayDelete,
  payload: id,
});


